// search_getObjBiggestAttIndex_n
export const re_startAndEndWith_s = (start_s, end_s) => {

    // g =	Global search.
    // .*? all charters - lazy
    return new RegExp(`${start_s}.*?${end_s}`, 'g')
}


// re_hasNumber_fb
export const re_hasNumber_fb = (string_s) => {
    return /\d/.test(string_s);
}

// re_hasNumber_fb
export const re_hasLetter_fb = (string_s) => {

    return /[a-zA-Z]/g.test(string_s) || /[א-ת]/g.test(string_s)
}

// re_validEmailAddress_fb
export const re_validEmailAddress_fb = (email_s) => {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email_s).toLowerCase());
}


